import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { fontRobotoCondensed, ZIndexLayer } from "shared/lib/styles";

import { setResponsiveHeaderFontSize } from "scmp-app/components/header/header-oneline-menu-container/header-all-menu/common/styles";

export const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  block-size: 32px;
  padding-block: 0;
  padding-inline: 12px 8px;

  border-radius: 4px;

  background: #2c4692;
`;

export const EditionText = styled.div`
  color: #ffffff;
  font-family: ${fontRobotoCondensed};
  line-height: normal;

  ${setResponsiveHeaderFontSize()};
`;

export const Edition = styled(Button)`
  padding: 0;

  color: #ffffff;
  font-weight: 700;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  letter-spacing: normal;
  text-transform: capitalize;

  cursor: pointer;

  span {
    display: flex;
    align-items: center;

    margin-inline-start: 4px;
  }

  ${setResponsiveHeaderFontSize()};
`;

export const EditionMenu = styled(Menu)`
  z-index: ${ZIndexLayer.EditionInvitation};
`;

export const EditionMenuItem = styled(MenuItem)`
  min-block-size: auto;
  padding-block: 8px;
  padding-inline: 20px;

  color: #000000;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;

  &:hover {
    background-color: transparent;
  }

  &&.Mui-selected {
    color: #2c4692;
  }
`;
